import useQueryString from '@/hooks/router/useQueryString';
import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';

const qsValues = [
    {
        key: 'type' as 'type',
        names: [
            'type'
        ]
    }
]

const Error: FC = () => {
    const [show, setShow] = useState(false);

    const { type } = useQueryString(qsValues);

    useEffect(() => {
        const id = setTimeout(() => setShow(true), 5000);

        return () => {
            clearTimeout(id);
        }
    }, [setShow])

    return (
        <Box
            sx={{
                w: '100vh',
                h: '100vh',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                position: 'fixed',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2
            }}
        >
            <Box
                sx={{
                    textAlign: 'center'
                }}
            >
                <Box
                    sx={{ mb: 2}}
                >
                    <CircularProgress size={96} />
                </Box>
                <Box
                    sx={{
                        fontSize: '2rem',
                        fontWeight: 'bold'
                    }}
                >
                    {type ?? 'Redirecting...'}
                </Box>
                <Box
                    sx={{
                        mt: 2,
                        transition: 'opacity 2s ease',
                        opacity: show ? 1 : 0
                    }}
                >
                    The request appears to be taking longer than expected click the button below to return to the TROG Cancer Research website.
                    <br /><br />
                    <Button
                        variant="contained"
                        component="a"
                        href={import.meta.env.VITE_API_WEBSITE_URL}
                    >
                        Home
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default Error;